import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postRequest } from "../../../config/dataApi";
import ENDPOINTS from "../../../config/apiUrls";
import { toast } from "react-toastify";
import AccountsHeader from "./header";

// Formik validation schema
const validationSchema = Yup.object({
  zipCode: Yup.string().required("Zip Code is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
});

const Billing = () => {
  const formik = useFormik({
    initialValues: {
      zipCode: "",
      address: "",
      city: "",
      state: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        // Replace with your actual billing address update endpoint and payload
        await postRequest(ENDPOINTS.SUPPORT.CONTACT, {
          data: {
            type: "billing-address",
            attributes: {
              zipCode: values.zipCode,
              address: values.address,
              city: values.city,
              state: values.state,
            },
          },
        });

        resetForm();
        toast.success("Your billing address has been updated successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      } catch (error) {
        console.error("Error updating billing address:", error);
        toast.error("An error occurred. Please try again.", {
          position: "top-right",
        });
      }
    },
  });

  return (
    <div>
      <h1 className="section_heading">Billing Address</h1>
      <AccountsHeader />

      <form className="form_div" onSubmit={formik.handleSubmit}>
        <div className="form-card">
          <div className="form-elements">
            <div className="custom-form-group">
              <label htmlFor="zipCode">Zip Code</label>
              <input
                type="text"
                id="zipCode"
                name="zipCode"
                value={formik.values.zipCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.zipCode && formik.errors.zipCode ? (
                <div className="error-text">{formik.errors.zipCode}</div>
              ) : null}
              <hr
                className={
                  formik.touched.zipCode && formik.errors.zipCode
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
            <div className="custom-form-group">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                id="address"
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.address && formik.errors.address ? (
                <div className="error-text">{formik.errors.address}</div>
              ) : null}
              <hr
                className={
                  formik.touched.address && formik.errors.address
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
            <div className="custom-form-group">
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                name="city"
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.city && formik.errors.city ? (
                <div className="error-text">{formik.errors.city}</div>
              ) : null}
              <hr
                className={
                  formik.touched.city && formik.errors.city
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
            <div className="custom-form-group">
              <label htmlFor="state">State</label>
              <input
                type="text"
                id="state"
                name="state"
                value={formik.values.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.state && formik.errors.state ? (
                <div className="error-text">{formik.errors.state}</div>
              ) : null}
              <hr
                className={
                  formik.touched.state && formik.errors.state
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="button-div">
            <button type="submit" disabled={formik.isSubmitting}>
              <span>{formik.isSubmitting ? "Updating..." : "Update"}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Billing;
